import React from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import { logout } from "../../../Account/action-creators";
import FeedbackButton from "Shared/Button/Feedback";
import Button from "Shared/Button";
import { logoutGtm } from "../../../TrackingInformation";
const handleOktaLogoutClick = (currentUser) => {
    if (!currentUser.isImpersonating) {
        logoutGtm('Username/Password', null, null);
    }
    window.location.href = "/Logout/OktaLogout";
};
const LogOut = (prop) => (React.createElement("div", { className: styles.container }, prop.isImpersonating ? (React.createElement(FeedbackButton, { type: "button", onClickWithFeedback: (e, activate) => activate(prop.logout()), className: styles.text, tabIndex: prop.tabIndex }, prop.text)) : (React.createElement(Button, { type: "button", onClick: () => handleOktaLogoutClick(prop.currentUser), className: styles.text, tabIndex: prop.tabIndex }, prop.text))));
export default connect((state) => ({
    isImpersonating: !!state.currentUser && state.currentUser.isImpersonating,
    currentUser: state.currentUser,
}), (dispatch) => ({ logout: () => dispatch(logout()) }))(LogOut);
